import { App } from './app.js';
import { applyAnimationSetting, getStoredSettings } from './settings.js';
import { initTheme } from './theme.js';
import { WordConnectApp } from './WordConnectApp.js';

initTheme();
applyAnimationSetting(getStoredSettings().animations);

const root = document.getElementById('app');
if (!root) {
  throw new Error('#app element not found');
}

if (window.location.hash === '#words') {
  new WordConnectApp(root);
} else {
  new App(root);
}
